import { getAssetURL } from 'src/constants/BlockchainConstants'
import { useAppSelector } from 'src/store/store'
import { maskHash } from 'src/constants/ConversionUtils'
import { CopyLink } from 'src/components/shared/CopyLink'

type Props = {
  blockchain: string
  assetDenomOrAddress: string
  shouldTruncate?: boolean
}

export const ExplorerAssetLink: React.FC<Props> = ({
                                                     blockchain,
                                                     assetDenomOrAddress,
                                                     shouldTruncate = false,
                                                   }) => {
  const selector = useAppSelector
  const network = selector((state) => state.NetworkReducer.network)
  // const tokenState: TokenState = selector((state) => state.TokenReducer)

  if (!assetDenomOrAddress || !blockchain) {
    return <div>{'-'}</div>
  }

  // link to transactions page in respective explorers
  const explorerUrl = getAssetURL(blockchain, assetDenomOrAddress, network)
  if (!explorerUrl) {
    return <div>{assetDenomOrAddress.slice(0, 5)}... (Link not found)</div>
  }

  const formattedHash = shouldTruncate
    ? maskHash(assetDenomOrAddress, 40)
    : assetDenomOrAddress

  if (
    assetDenomOrAddress === '0x0000000000000000000000000000000000000000' ||
    assetDenomOrAddress === 'zil1qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq9yf6pz'
  ) {
    return <div>{formattedHash}</div>
  }
  return <CopyLink copyText={assetDenomOrAddress} text={formattedHash} url={explorerUrl} />
}
